const KEY = "kk-chunk-reload";

// After a deploy, a tab opened on the old build asks for chunk files that no longer exist.
// Reload once to pick up the new build; if the chunk still fails after that, surface the error.
export default function withChunkReload(load) {
  return load().then(
    (module) => {
      sessionStorage.removeItem(KEY);
      return module;
    },
    (err) => {
      if (err?.name !== "ChunkLoadError" || sessionStorage.getItem(KEY)) throw err;
      sessionStorage.setItem(KEY, "1");
      window.location.reload();
      return new Promise(() => {});
    }
  );
}
